import firebase from "firebase/app";

import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import removeTeamMember from "astrid-firestore/src/api/productions/team/removeTeamMember";

import { getAgreementAdminURL } from "../../../../agreements/utils/agreementsHelper";
import useHasRight from "../../../../authorization/hooks/useHasRight";

import { getTeamMemberOpenCost } from "../../../utils/teamHelper";

export default function useTeamMemberDropdownMenuOptions({ member, production, setOpen }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();

	const { agreement } = member;
	return [
		{
			text: t("view", "View"),
			to: getAgreementAdminURL(agreement),
			disabled: !agreement,
			hidden: !hasRight("agreements.view"),
		},
		{
			text: t("edit", "Edit"),
			action: async () => {
				const openCost = await getTeamMemberOpenCost({ member, production });

				if (openCost?.openAmount) {
					throw new Error(
						t(
							"memberHasOpenCosts",
							"The member you are trying to edit has open costs. You can edit this member after either finalizing or deleting the cost.",
						),
					);
				}

				setOpen(true);
			},
		},
		{
			text: t("remove", "Remove"),
			action: async () => {
				try {
					await removeTeamMember(db, firebase.firestore, { member, production });
				} catch (error) {
					if (error.message === "Member has open cost") {
						throw new Error(
							t(
								"deleteMemberMessage",
								"The member you are removing has an open cost. You can remove this member after either finalizing or deleting the cost.",
							),
						);
					}

					if (error.message === "Member has booked sessions") {
						throw new Error(
							t(
								"memberHasBookedSessions",
								"The member you are removing has booked sessions. You can remove this member after either completing or cancelling the sessions.",
							),
						);
					}

					throw error;
				}
			},
			confirmText: t("removeTeamMemberConfirmation", "Are you sure you want to remove this team member?"),
		},
	];
}
